export default __webpack_public_path__ + "static/unpaid-to-paid-invoice-d64513d0aae461e4b2be0b5e4e51603e.png";